import { rem } from '../../lib/rem';

export function ProgressBar({
  pending,
  inProgress,
  complete,
  total,
}: {
  pending: number;
  inProgress: number;
  complete: number;
  total: number;
}) {
  if (total === 0)
    return <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--tm)' }}>None yet</span>;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: rem(6) }}>
      <div
        style={{
          display: 'flex',
          width: rem(56),
          height: rem(6),
          borderRadius: rem(3),
          overflow: 'hidden',
          background: 'var(--sa)',
          flexShrink: 0,
        }}
      >
        <div style={{ width: `${(complete / total) * 100}%`, background: 'var(--ok)' }} />
        <div
          style={{
            width: `${(inProgress / total) * 100}%`,
            background: 'var(--color-warning)',
          }}
        />
      </div>
      <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--tm)', whiteSpace: 'nowrap' }}>
        {complete} done &middot; {inProgress} active &middot; {pending} pending
      </span>
    </div>
  );
}
